const DefaultMetricConfig = {
  footerHeight: 50,
  baseMargin: 15,
  basePadding: 15,
};

export default DefaultMetricConfig;
